import React from "react";
import { Tab, Nav, Card, Button } from "react-bootstrap";
import {
  ClipboardCheck,
  CalendarEvent,
  ClipboardData,
  HeartPulse,
  ListCheck,
  FileText,
  SignDeadEnd,
  SignIntersectionT,
  SignIntersection,
  Eye,
  ArrowLeft,
} from "react-bootstrap-icons";
import PreauthorizationRequestNested from "./PreauthorizationRequestNested";
import PreauthorizationEncounterNested from "./PreauthorizationEncounterNested";
import PreauthorizationMedicalDetailsNested from "./PreauthorizationMedicalDetailsNested";
import PreauthorizationVitalNested from "./PreauthorizationVitalNested";
import PreauthorizationDiagnosisNested from "./PreauthorizationDiagnosisNested";
import PreauthorizationServicesProceduresNested from "./PreauthorizationServicesProceduresNested";
import PreauthorizationClinialDocumentNested from "./PreauthorizationClinialDocumentNested";
import PreauthorizationOpticalNested from "./PreauthorizationOpticalNested";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import paths from "routes/paths";
import PreauthProviderRequest from "./new-view-preauth-components/PreauthProviderRequest";
import PreauthProviderEncounter from "./new-view-preauth-components/PreauthProviderEncounter";
import PreauthProviderVitalSign from "./new-view-preauth-components/PreauthProviderVitalSign";
import PreauthProviderMedical from "./new-view-preauth-components/PreauthProviderMedical";
import PreauthProviderDiagnosis from "./new-view-preauth-components/PreauthProviderDiagnosis";
import PreauthProviderServices from "./new-view-preauth-components/PreauthProviderServices";
import PreauthProviderClinicalDocument from "./new-view-preauth-components/PreauthProviderClinical";
import PreauthProviderOptical from "./new-view-preauth-components/PreauthProviderOptical";

const PreauthorizationProvideRequest = () => {
  const { viewPreauthorizationInfo } = useSelector(
    (state) => state.preauthorization
  );
  const { viewClaimInfo, claimRequestData } = useSelector(
    (state) => state.claim
  );

  const { id } = useParams();

  const isEncounterEmpty = (encounter) => {
    console.log({ encounter });
    if (!encounter) return true;

    const isEmptyValue = (val) => {
      return val === null || val === undefined || val === "";
    };

    return Object.values(encounter).every(isEmptyValue);
  };

  console.log({
    test: !isEncounterEmpty(
      viewPreauthorizationInfo?.provider_request?.encounter
    ),
  });

  const preauthorizationEncounter =
    !isEncounterEmpty(viewPreauthorizationInfo?.provider_request?.encounter) ||
    claimRequestData?.entry?.find(
      (e) => e.resource?.resourceType === "Encounter"
    )?.resource?.id;

  const navigate = useNavigate();

  const isClaim = !!claimRequestData?.id;

  return (
    <Tab.Container defaultActiveKey="preAuthRequest">
      <Card>
        <Nav
          variant="tabs"
          className="border-0 d-flex align-items-center mb-2 px-2"
        >
          {id && (
            <Button
              variant="secondary"
              className="me-3"
              size="sm"
              onClick={() =>
                navigate(
                  isClaim ? paths.claimsList : paths.preauthorizationList
                )
              }
            >
              <ArrowLeft size={18} />
            </Button>
          )}
          {/* Pre-Authorization Request or Claim Request Tab */}
          <Nav.Item>
            <Nav.Link
              eventKey="preAuthRequest"
              className="d-flex align-items-center fs-10 text-600 gap-2"
            >
              <ClipboardCheck />{" "}
              {isClaim ? "Claim Request" : "Pre-Authorization Request"}
            </Nav.Link>
          </Nav.Item>

          {/* Encounter Tab */}
          {preauthorizationEncounter && (
            <Nav.Item>
              <Nav.Link
                eventKey="encounter"
                className="d-flex align-items-center fs-10 text-600 gap-2"
              >
                <CalendarEvent />
                Encounter
              </Nav.Link>
            </Nav.Item>
          )}
          {(viewPreauthorizationInfo?.claim_typenme?.toLowerCase() ===
            "vision" ||
            viewClaimInfo?.claim_type === "vision") && (
            <Nav.Item>
              <Nav.Link
                eventKey="optical"
                className="d-flex align-items-center fs-10 text-600 gap-2"
              >
                <Eye /> Optical
              </Nav.Link>
            </Nav.Item>
          )}
          {viewPreauthorizationInfo?.claim_typenme !== "vision" && (
            <Nav.Item>
              <Nav.Link
                eventKey="vital"
                className="d-flex align-items-center fs-10 text-600 gap-2"
              >
                <SignIntersection />
                Vital Sign
              </Nav.Link>
            </Nav.Item>
          )}

          {/* Medical Details Tab */}
          <Nav.Item>
            <Nav.Link
              eventKey="medicalDetails"
              className="d-flex align-items-center fs-10 text-600 gap-2"
            >
              <ClipboardData /> Medical Details
            </Nav.Link>
          </Nav.Item>

          {/* Diagnosis Tab */}
          <Nav.Item>
            <Nav.Link
              eventKey="diagnosis"
              className="d-flex align-items-center fs-10 text-600 gap-2"
            >
              <HeartPulse />
              Diagnosis
            </Nav.Link>
          </Nav.Item>

          {/* Services & Procedures Tab */}
          <Nav.Item>
            <Nav.Link
              eventKey="servicesProcedures"
              className="d-flex align-items-center fs-10 text-600 gap-2"
            >
              <ListCheck />
              Services & Procedures
            </Nav.Link>
          </Nav.Item>

          {/* Clinical Documentation Tab */}
          <Nav.Item>
            <Nav.Link
              eventKey="clinicalDoc"
              className="d-flex fs-10 text-600 align-items-center gap-2"
            >
              <FileText />
              Clinical Documentation
            </Nav.Link>
          </Nav.Item>
        </Nav>

        <Tab.Content className="p-3">
          <Tab.Pane eventKey="preAuthRequest">
            {isClaim ? (
              <PreauthorizationRequestNested />
            ) : (
              <PreauthProviderRequest />
            )}
          </Tab.Pane>

          {preauthorizationEncounter && (
            <Tab.Pane eventKey="encounter">
              {isClaim ? (
                <PreauthorizationEncounterNested />
              ) : (
                <PreauthProviderEncounter />
              )}
            </Tab.Pane>
          )}
          {(viewPreauthorizationInfo?.claim_typenme === "vision" ||
            viewClaimInfo?.claim_type === "vision") && (
            <Tab.Pane eventKey="optical">
              {isClaim ? (
                <PreauthorizationOpticalNested />
              ) : (
                <PreauthProviderOptical />
              )}
            </Tab.Pane>
          )}
          <Tab.Pane eventKey="vital">
            {isClaim ? (
              <PreauthorizationVitalNested />
            ) : (
              <PreauthProviderVitalSign />
            )}
          </Tab.Pane>

          <Tab.Pane eventKey="medicalDetails">
            {isClaim ? (
              <PreauthorizationMedicalDetailsNested />
            ) : (
              <PreauthProviderMedical />
            )}
          </Tab.Pane>

          <Tab.Pane eventKey="diagnosis">
            {isClaim ? (
              <PreauthorizationDiagnosisNested />
            ) : (
              <PreauthProviderDiagnosis />
            )}
          </Tab.Pane>

          <Tab.Pane eventKey="servicesProcedures">
            {isClaim ? (
              <PreauthorizationServicesProceduresNested />
            ) : (
              <PreauthProviderServices />
            )}
          </Tab.Pane>

          <Tab.Pane eventKey="clinicalDoc">
            {isClaim ? (
              <PreauthorizationClinialDocumentNested />
            ) : (
              <PreauthProviderClinicalDocument />
            )}
          </Tab.Pane>
        </Tab.Content>
      </Card>
    </Tab.Container>
  );
};

export default PreauthorizationProvideRequest;
